import React from 'react';
import PropTypes from 'prop-types';

const IcoOption = ({ onSelect, onFocus, isFocused, option, className, children }) => {
  const handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSelect(option, event);
  };
  const handleMouseEnter = (event) => {
    onFocus(option, event);
  };
  const handleMouseMove = (event) => {
    if (isFocused) return;
    onFocus(option, event);
  };
  const iconStyle = {
    width: 20,
    height: 15,
    borderRadius: '3px',
    marginRight: '8px'
  };
  const colorStyle = {
    width: 20,
    height: 15,
    backgroundColor: option.bg,
    display: 'inline-block',
    borderRadius: '3px',
    marginRight: '8px',
    position: 'relative',
    top: '2px'
  };

  let iconState;
  if (option.icon) {
    iconState = <img src={option.icon} style={iconStyle} role="presentation" />;
  } else if (option.bg) {
    iconState = <span style={colorStyle} />;
  } else {
    iconState = '';
  }

  return (
    <div
      className={className}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseMove={handleMouseMove}
    >
      {iconState} {children}
    </div>
  );
};

IcoOption.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isDisabled: PropTypes.bool,
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
  onFocus: PropTypes.func,
  onSelect: PropTypes.func,
  option: PropTypes.object.isRequired
};

export default IcoOption;



// WEBPACK FOOTER //
// ./src/components/OptionSelector/IcoOption.js


// WEBPACK FOOTER //
// webpack:///src/components/OptionSelector/IcoOption.js